import React from "react";
import style from "../../Styles/Components/LogoTitle.module.css";


const LogoTitle = ({ logo, content }) => (
  <div className={style.logoContainer}>
    <div className={style.logo}>{logo}</div>
    <div className={style.content}>
    {content.split('\n').map((item, idx) => 
      <span key={idx}> 
        {item} 
        <br/> 
      </span> 
    )}
     </div>
  </div>
);

export default LogoTitle;
